import { mergePaginatedDataAndValue } from '@issuemanager/apps/client/components';
import { MIN_CHARACTERS_TO_SEARCH } from '@issuemanager/apps/client/utils';
import { useInfiniteUsers } from '@issuemanager/client/features/users';
import { useMemo } from 'react';

type Props = {
  values: any[];
  filterByText: string;
};

export const useUsersToNotify = ({ values, filterByText }: Props) => {
  const usersQuery = useInfiniteUsers({
    filter: {
      searchTerm: filterByText,
    },
    enabled: filterByText.length >= MIN_CHARACTERS_TO_SEARCH,
    handleError: true,
  });

  const users = useMemo(
    () => usersQuery.data?.pages.map((c) => c.data.map((d) => d)) ?? [],
    [usersQuery.data],
  );

  const options = useMemo(
    () => mergePaginatedDataAndValue(users, values, (option) => option.id),
    [users, values],
  );

  return {
    loading: usersQuery.isLoading,
    options,
  };
};
